import { useQuery } from 'react-query';

import { getUnmountedMCT } from 'api/InteractiveMap/getUnmountedMCT';
import { Device } from 'api/InteractiveMap/types';

type DeviceType = 'mct' | 'srbm' | 'smst' | 'srst';

export const useGetUnmountedDevices = (siteSlug: string, deviceType: DeviceType) => {
  const { data, refetch, isLoading, isRefetching } = useQuery(
    ['unmountedDevices', deviceType],
    () => getUnmountedMCT(siteSlug),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      enabled: !!siteSlug,
      select: data => data[deviceType] as Device[],
    },
  );

  return { data, refetch, isLoading, isRefetching };
};
